import * as PIXI from 'pixi.js';
import { isMobile } from 'react-device-detect';
import { BOLD_FONT_FAMILY, DEFAULT_FONT_FAMILY, SECONDARY_FONT_FAMILY } from '../constants/constants';
import { ALERT_BUTTON_TEXT_COLOR_NUM, ALL_IN_PLAYER_STATUS_COLOR_NUM, ALL_IN_PLAYER_STATUS_STROKE_COLOR_NUM, BET_POT_TEXT_STROKE_COLOR_NUM, BUTTON_SUB_LABEL_COLOR_NUM, CHIP_LEADER_PLAYER_STATUS_COLOR_NUM, JACKS_POT_COLOR_NUM, JACKS_POT_SUBTLE_COLOR_NUM, POT_LABEL_COLOR_NUM, SIDE_BET_BUTTON_SUB_LABEL_COLOR_NUM, SIDE_BETS_ACCENT_COLOR_NUM } from './colors';
export const SECONDARY_FONT_STYLE_BASE = {
    fontFamily: SECONDARY_FONT_FAMILY,
    fill: 0xffffff,
    fontSize: isMobile ? 14 : 16,
    stroke: BET_POT_TEXT_STROKE_COLOR_NUM,
    strokeThickness: isMobile ? 3 : 5,
    lineJoin: 'round'
};
export const POT_AMOUNT_TEXT_STYLE = new PIXI.TextStyle(SECONDARY_FONT_STYLE_BASE);
export const JACKS_POT_AMOUNT_TEXT_STYLE = new PIXI.TextStyle({
    ...POT_AMOUNT_TEXT_STYLE,
    fill: JACKS_POT_COLOR_NUM
});
export const POT_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    ...SECONDARY_FONT_STYLE_BASE,
    fontSize: isMobile ? 12 : 14,
    strokeThickness: isMobile ? 3 : 4,
    fill: POT_LABEL_COLOR_NUM
});
export const ACTIVE_PLAYER_CHIPS_TEXT_STYLE = new PIXI.TextStyle({ ...SECONDARY_FONT_STYLE_BASE, fill: 0xcccccc });
export const INACTIVE_STATUS_TEXT_STYLE = new PIXI.TextStyle({
    ...SECONDARY_FONT_STYLE_BASE,
    fill: 0x777777,
    stroke: 0x222222
});
export const PLAYER_JACKS_TEXT_STYLE = new PIXI.TextStyle({
    ...ACTIVE_PLAYER_CHIPS_TEXT_STYLE,
    fill: JACKS_POT_COLOR_NUM
});
export const PLAYER_JACKS_SUBTLE_TEXT_STYLE = new PIXI.TextStyle({
    ...PLAYER_JACKS_TEXT_STYLE,
    fill: JACKS_POT_SUBTLE_COLOR_NUM
});
export const BET_BUTTON_SUB_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    fontFamily: SECONDARY_FONT_FAMILY,
    fill: BUTTON_SUB_LABEL_COLOR_NUM,
    fontSize: isMobile ? 14 : 18
});
export const SET_BET_BUTTON_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    fontFamily: SECONDARY_FONT_FAMILY,
    fill: 0x000000,
    fontSize: isMobile ? 14 : 18
});
export const SIMPLE_BET_BUTTON_LABEL_TEXT_STYLE = SET_BET_BUTTON_LABEL_TEXT_STYLE;
export const FOLDED_HOLE_CARDS_TEXT_STYLE = new PIXI.TextStyle({
    ...SECONDARY_FONT_STYLE_BASE,
    fill: 0x888888,
    stroke: 0x222222,
    strokeThickness: isMobile ? 2 : 4
});
export const REVEALING_HOLE_CARDS_TEXT_STYLE = new PIXI.TextStyle({
    ...SECONDARY_FONT_STYLE_BASE,
    stroke: 0x222222,
    strokeThickness: isMobile ? 2 : 4
});
export const ALL_IN_TEXT_STYLE = new PIXI.TextStyle({
    ...SECONDARY_FONT_STYLE_BASE,
    fill: ALL_IN_PLAYER_STATUS_COLOR_NUM,
    stroke: ALL_IN_PLAYER_STATUS_STROKE_COLOR_NUM
});
export const CHIP_LEADER_TEXT_STYLE = new PIXI.TextStyle({
    ...SECONDARY_FONT_STYLE_BASE,
    fill: CHIP_LEADER_PLAYER_STATUS_COLOR_NUM,
    fontSize: isMobile ? 12 : 14,
    strokeThickness: isMobile ? 3 : 4
});
export const BET_BUTTON_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    fontSize: 22,
    fontFamily: DEFAULT_FONT_FAMILY,
    fill: 0x000000
});
export const AUTO_BET_BUTTON_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    ...BET_BUTTON_LABEL_TEXT_STYLE,
    fill: 0x888888
});
export const ENABLED_AUTO_BET_BUTTON_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    ...BET_BUTTON_LABEL_TEXT_STYLE,
    fill: ALERT_BUTTON_TEXT_COLOR_NUM
});
export const DISCARD_ONE_TEXT_STYLE = new PIXI.TextStyle({
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: 24,
    fill: 0x000000
});
const WINNING_HAND_NAME_TEXT_STYLE_BASE = {
    fontFamily: DEFAULT_FONT_FAMILY,
    letterSpacing: -1,
    fontSize: isMobile ? 18 : 20,
    fill: 0xffffff
};
export const WINNING_HAND_NAME_TEXT_STYLE = new PIXI.TextStyle({
    ...WINNING_HAND_NAME_TEXT_STYLE_BASE,
    fontFamily: BOLD_FONT_FAMILY,
    fontSize: isMobile ? 18 : 20
});
export const WINNING_HAND_SUB_NAME_TEXT_STYLE = new PIXI.TextStyle({
    ...WINNING_HAND_NAME_TEXT_STYLE_BASE,
    fontSize: isMobile ? 14 : 16
});
export const PLAYER_BUBBLE_CARD_RANK_TEXT_STYLE = new PIXI.TextStyle({
    fontFamily: DEFAULT_FONT_FAMILY,
    fill: 0x000000,
    fontSize: 20
});
export const SIDE_BET_BUTTON_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    ...BET_BUTTON_LABEL_TEXT_STYLE,
    fill: SIDE_BETS_ACCENT_COLOR_NUM
});
export const SIDE_BET_BUTTON_SUB_LABEL_TEXT_STYLE = new PIXI.TextStyle({
    ...BET_BUTTON_SUB_LABEL_TEXT_STYLE,
    fill: SIDE_BET_BUTTON_SUB_LABEL_COLOR_NUM
});
export const SIDE_BET_NAME_ANIMATION_TEXT_STYLE = new PIXI.TextStyle({
    ...BET_BUTTON_LABEL_TEXT_STYLE,
    fill: 0xffffff,
    stroke: 0,
    strokeThickness: 5,
    lineJoin: 'round'
});
export const PLAYER_BUBBLE_CARD_RANK_LETTER_SPACING = -2; // makes '10' more compact
